/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {SENSOR_TYPES} from "../../../../constants/globalVariables";


const sensorRadarTitle = "Radar Database";
const errorMessagesTitle = 'Error & Warning Messages:'
const fileProcessingMessagesTitle = 'File Processing Messages:'

const addRadarEndpoint = `/HttpTriggerSensors?req=add&type=${SENSOR_TYPES.RADAR}`
const deleteRadarTempFileEndpoint = "/HttpTriggerSensors?req=delete&type=radar-temp-file"
const addRadarConfigEndpoint = "/HttpTriggerSensors?req=add&type=radar-config"
const deleteRadarConfigEndpoint = "/HttpTriggerSensors?req=delete&type=radar-config"
const getRadarDetailsEndpoint = "/HttpTriggerSensors?req=get&type=radar-details"
const getRadarLandingEndpoint = "/HttpTriggerSensors?req=get&type=radar-landing"
const getRadarPlotEndpoint = "/HttpTriggerSensors?req=get&type=radar-plot"
const uploadFileRadarEndpoint = `/HttpTriggerSensors?req=upload-file&type=${SENSOR_TYPES.RADAR}`

const baseSensorRequestEndpoint = "/HttpTriggerSensors"
const buildSensorRequestEndpoint = (req: string, type: string) => {
  return `${baseSensorRequestEndpoint}?req=${req}&type=${type}`
}

const SENSOR_REQUEST_ENDPOINTS = {
  deleteSensor: buildSensorRequestEndpoint('delete', 'deleteSensor'),
  shouldDeleteSensor: buildSensorRequestEndpoint('delete', 'shouldDeleteSensor'),
}

export interface Radar {
  baseline: any;
  id: string
  type: string
  version: string
  dateCreated: string
  plotData: any
  configurations: any
  owner: string
  isPublicConfig: string
  radarType: string
  supplier: string
  component: string
  componentVersion: string
  detectionDegradation: number
  maxInstrumentedRange: number
  azimuthFOV: number
  elevationFOV: number
  txPowerHot: number
  singleSideBandNoiseHot: number
  twoWayAntannaGainHot: number
  twoWayRadomeTxLineLossesHot: number
  numTxRxChannels: number
  isRxIqOrReal: number
  totalChirpTimePerFrame: number
  txChannelsTransmitSimultaneouslyTdmOrFdm: number
}
export interface SensorRadarRow {
  component: string,
  supplier: string, 
  version: string, 
  dateCreated: string, 
  sub: SensorRadarRow[]
}
export {
  sensorRadarTitle,
  errorMessagesTitle,
  fileProcessingMessagesTitle,
  addRadarEndpoint,
  addRadarConfigEndpoint,
  deleteRadarConfigEndpoint,
  getRadarDetailsEndpoint,
  getRadarLandingEndpoint,
  getRadarPlotEndpoint,
  uploadFileRadarEndpoint, 
  deleteRadarTempFileEndpoint,

  SENSOR_REQUEST_ENDPOINTS
}
